// extracted by mini-css-extract-plugin
var _1 = "#188efe";
var _2 = "#0d6fd9";
var _3 = "#1890ff";
export { _1 as "arovyBlue", _2 as "pardotBlue", _3 as "salesforceBlue" }
